import { HeaderCommonProps } from "@components/Header/types";
import { useWindowSize } from "@hooks/useWindowSize";
import MyAccountLoginTrigger from "@routes/MyAccount/components/MyAccountLoginTrigger";
import MyAccountPopoverLogin from "@routes/MyAccount/components/MyAccountPopoverLogin/MyAccountPopoverLogin";

export default function MyAccountHeaderFactoryAnonTriger({
  textClassName,
}: Pick<HeaderCommonProps, "textClassName">): React.ReactElement {
  const { isScreenLG } = useWindowSize();

  if (isScreenLG)
    return <MyAccountPopoverLogin textClassName={textClassName} />;

  return <MyAccountLoginTrigger textClassName={textClassName} />;
}
